/* resources/scripts/search.js */

/* ------------------------------
   Utilities
------------------------------ */
const qs  = (s, r = document) => r.querySelector(s);
const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));

function meta(name) {
  const el = document.querySelector(`meta[name="meili:${name}"]`);
  return el && el.content ? el.content.trim() : null;
}

function waitForLibs(maxMs = 3000) {
  return new Promise((resolve, reject) => {
    const t0 = performance.now();
    (function tick () {
      if (window.instantsearch && window.instantMeiliSearch) return resolve();
      if (performance.now() - t0 > maxMs) return reject(new Error('instantsearch libs not loaded'));
      setTimeout(tick, 50);
    })();
  });
}

const fmtEUR = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });
const priceText = v => (v === null || v === '' || isNaN(Number(v))) ? '' : fmtEUR.format(Number(v));

/* ------------------------------
   Hits template (met add-to-cart)
------------------------------ */
function priceHtml(hit) {
  if (hit.price_html) return hit.price_html;
  const price = (typeof hit.price === 'number') ? hit.price : null;
  const sale  = (typeof hit.sale_price === 'number') ? hit.sale_price : null;
  if (price && sale && sale > 0 && sale < price) {
    return `<span class="price">
      <del><span class="amount">${priceText(price)}</span></del>
      <ins><span class="amount">${priceText(sale)}</span></ins>
    </span>`;
  }
  if (price) return `<span class="price"><span class="amount">${priceText(price)}</span></span>`;
  return '';
}

function addToCartMarkup(hit) {
  const type = (hit.type || '').toLowerCase();
  const link = hit.permalink || hit.url || '#';
  if (type && type !== 'variable' && hit.add_to_cart_url) {
    const classes = [
      'button',
      `product_type_${type}`,
      'add_to_cart_button',
      hit.ajax_add_to_cart ? 'ajax_add_to_cart' : ''
    ].filter(Boolean).join(' ');
    const label = (hit.add_to_cart_label || hit.add_to_cart_text || 'In winkelwagen')
      .toString().replace(/"/g, '&quot;');
    return `<a href="${hit.add_to_cart_url}"
              rel="nofollow"
              data-quantity="1"
              data-product_id="${(hit.id ?? '').toString().replace(/"/g,'&quot;')}"
              class="${classes}"
              aria-label="${label}">
              ${label}
            </a>`;
  }
  return `<a class="button button--secondary" href="${link}">
            ${type === 'variable' ? 'Selecteer opties' : 'Bekijk'}
          </a>`;
}

function wkHitsTemplate(hit) {
  const url   = hit.permalink || hit.url || '#';
  const title = hit.title || hit.name || '(zonder titel)';
  const catsArr =
    Array.isArray(hit.categories) ? hit.categories :
    Array.isArray(hit.category)   ? hit.category   : null;
  const cats  = catsArr ? catsArr.join(' › ') : (hit.category || '');
  const img   = hit.image || hit.thumbnail || '';
  const imgTag = img ? `<img src="${img}" alt="${(hit.image_alt || title).replace(/"/g,'&quot;')}" class="wk-hit__img" loading="lazy">` : '';

  return `
    <article class="wk-hit">
      <a class="wk-hit__thumb" href="${url}" aria-label="${title}">
        ${imgTag}
      </a>
      <div class="wk-hit__body">
        <a class="wk-hit__title" href="${url}">
          <h4>${title}</h4>
        </a>
        ${cats ? `<div class="wk-hit__cats">${cats}</div>` : ''}
        <div class="wk-hit__price">${priceHtml(hit)}</div>
        ${addToCartMarkup(hit)}
      </div>
    </article>
  `;
}

/* ------------------------------
   Recent & popular queries
------------------------------ */
const RECENT_KEY = 'wk_recent_queries';
function getRecent(){ try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch(e){ return []; } }
function setRecent(list){ localStorage.setItem(RECENT_KEY, JSON.stringify(list)); }
function pushRecent(q){
  if (!q || !q.trim()) return;
  const list = getRecent().filter(x => x.toLowerCase() !== q.toLowerCase());
  list.unshift(q.trim());
  while (list.length > 5) list.pop();
  setRecent(list);
}
const pill = (q) => `<a href="#" class="wk-pill" data-wk-q="${q.replace(/"/g,'&quot;')}">${q}</a>`;

async function fetchPopular(host, key, index, withSort = true) {
  const url = `${host.replace(/\/+$/,'')}/indexes/${encodeURIComponent(index)}/search`;
  const body = {
    q: '',
    limit: 8,
    ...(withSort ? { sort: ['popularity:desc'] } : {})
  };
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type':'application/json', 'X-Meili-API-Key': key },
    body: JSON.stringify(body)
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const json = await res.json();
  const hits = Array.isArray(json.hits) ? json.hits : [];
  return hits.map(h => (h.query || h.term || h.title || '').toString()).filter(Boolean);
}

async function renderPopularInto(el, host, key, docsIndex) {
  if (!el) return;
  if (!host || !key || !docsIndex) {
    el.innerHTML = `<span style="opacity:.6">—</span>`;
    return;
  }
  try {
    let rows = await fetchPopular(host, key, docsIndex, true);
    if (!rows.length) rows = await fetchPopular(host, key, docsIndex, false);
    el.innerHTML = rows.length ? rows.map(pill).join('') : `<span style="opacity:.6">—</span>`;
  } catch {
    el.innerHTML = `<span style="opacity:.6">—</span>`;
  }
}

function renderRecentInto(el) {
  if (!el) return;
  const list = getRecent();
  el.innerHTML = list.length ? list.map(pill).join('') : `<span style="opacity:.6">—</span>`;
}

function wireQueryPills(rootEl, search) {
  rootEl.addEventListener('click', (e) => {
    const a = e.target.closest('[data-wk-recent-queries] .wk-pill, [data-wk-popular-queries] .wk-pill');
    if (!a) return;
    e.preventDefault();
    const q = a.getAttribute('data-wk-q') || '';
    try {
      search.helper.setQuery(q);
      search.helper.search();
    } catch {/* no-op */}
  });
}

/* ------------------------------
   Sorting koppeling (Meili `sort`)
------------------------------ */
function bindSortSelect(selectEl, search) {
  if (!selectEl) return;

  const map = {
    'relevance':        '',            // default
    'price_asc':        'price:asc',
    'price_desc':       'price:desc',
    'date_desc':        'date:desc',
    'date_asc':         'date:asc',
    'rating_desc':      'rating:desc',
    'popularity_desc':  'popularity:desc'
  };

  let sortCfg = null;
  function applySort(val) {
    const rule = map[val] || '';
    try {
      if (sortCfg) search.removeWidgets([sortCfg]);
      sortCfg = window.instantsearch.widgets.configure(
        rule ? { sort: [rule] } : {}
      );
      search.addWidgets([sortCfg]);
      // extra zekerheid: helper param clear/set
      search.helper.setQueryParameter('sort', rule ? [rule] : undefined);
      search.helper.search();
    } catch {/* no-op */}
  }

  selectEl.addEventListener('change', () => applySort(selectEl.value));

  // initial
  if (selectEl.value) applySort(selectEl.value);
}

/* ------------------------------
   Main init
------------------------------ */
async function initWKSearch() {
  if (window.__wkSearchInit) return; // guard
  const anyRoot = qs('[data-wk-search-root]') || qs('[data-wk-live-results]');
  if (!anyRoot) return;

  try { await waitForLibs(); } catch (e) { console.warn('[Meili]', e.message); return; }

  const host   = meta('host');
  const key    = meta('key');
  const index  = meta('index');          // PRODUCT index
  const docsIx = meta('docs');           // Suggesties index (optioneel)

  if (!host || !key || !index) {
    console.warn('[Meili] ontbrekende meta', { host, key: !!key, index });
    return;
  }

  const searchClient = window.instantMeiliSearch(host, key, { primaryKey: 'id' });
  const search = window.instantsearch({ indexName: index, searchClient });

  /* ---------- 1) Searchboxen (geen debounce → direct) ---------- */
  const searchBoxes = qsa('[data-wk-searchbox]').map(el =>
    window.instantsearch.widgets.searchBox({
      container: el,
      placeholder: 'Zoek producten…',
      showReset: false,
      showSubmit: false,
      autofocus: false,
      queryHook(query, refine) { refine(query); } // <— direct, geen vertraging
    })
  );
  if (searchBoxes.length) search.addWidgets(searchBoxes);

  /* ---------- 2) ZOEKPAGINA ---------- */
  const pageRoot = qs('[data-wk-search-root][data-wk-context="page"]');
  if (pageRoot) {
    const widgets = [];

    const stats = qs('[data-wk-stats]', pageRoot);
    if (stats) widgets.push(window.instantsearch.widgets.stats({
      container: stats,
      templates: { text: d => `<strong>${d.nbHits}</strong> ${d.nbHits===1?'resultaat':'resultaten'}` }
    }));

    const cat = qs('[data-wk-refine-categories]', pageRoot);
    if (cat) widgets.push(window.instantsearch.widgets.refinementList({
      container: cat,
      attribute: 'categories',
      searchable: false, /* ← geen zoekje boven de filters */
      showMore: true,
      sortBy: ['name:asc']
    }));

    const stock = qs('[data-wk-refine-instock]', pageRoot);
    if (stock) widgets.push(window.instantsearch.widgets.toggleRefinement({
      container: stock,
      attribute: 'in_stock',
      on: true,
      label: 'Op voorraad'
    }));

    const price = qs('[data-wk-refine-price]', pageRoot);
    if (price) widgets.push(window.instantsearch.widgets.rangeInput({
      container: price,
      attribute: 'price',
      templates: { separatorText: '–', submitText: 'Filter' }
    }));

    const hits = qs('[data-wk-hits]', pageRoot);
    if (hits) widgets.push(window.instantsearch.widgets.hits({
      container: hits,
      escapeHTML: false,
      templates: { empty: '<div>Geen resultaten gevonden.</div>', item: wkHitsTemplate }
    }));

    const pag = qs('[data-wk-pagination]', pageRoot);
    if (pag) widgets.push(window.instantsearch.widgets.pagination({ container: pag, padding: 2 }));

    if (widgets.length) search.addWidgets(widgets);

    // Sorting
    const sortSelect = qs('[data-wk-sorting] select[name="order"]', pageRoot);
    bindSortSelect(sortSelect, search);

    // Recent & popular
    const recentEl  = qs('[data-wk-recent-queries]', pageRoot);
    const popularEl = qs('[data-wk-popular-queries]', pageRoot);
    renderRecentInto(recentEl);
    renderPopularInto(popularEl, host, key, docsIx);
    wireQueryPills(pageRoot, search);
  }

  /* ---------- 3) LIVE PANEL (onder header) ---------- */
  const panel = qs('[data-wk-live-results]');
  if (panel) {
    const widgets = [];

    const pst = qs('[data-wk-stats]', panel);
    if (pst) widgets.push(window.instantsearch.widgets.stats({
      container: pst,
      templates: { text: d => `<strong>${d.nbHits}</strong> ${d.nbHits===1?'resultaat':'resultaten'}` }
    }));

    const pcat = qs('[data-wk-refine-categories]', panel);
    if (pcat) widgets.push(window.instantsearch.widgets.refinementList({
      container: pcat,
      attribute: 'categories',
      searchable: false, /* ← geen zoekje boven de filters */
      showMore: true,
      sortBy: ['name:asc']
    }));

    const pstock = qs('[data-wk-refine-instock]', panel);
    if (pstock) widgets.push(window.instantsearch.widgets.toggleRefinement({
      container: pstock,
      attribute: 'in_stock',
      on: true,
      label: 'Op voorraad'
    }));

    const pprice = qs('[data-wk-refine-price]', panel);
    if (pprice) widgets.push(window.instantsearch.widgets.rangeInput({
      container: pprice,
      attribute: 'price',
      templates: { separatorText: '–', submitText: 'Filter' }
    }));

    const phits = qs('[data-wk-hits]', panel);
    if (phits) widgets.push(window.instantsearch.widgets.hits({
      container: phits,
      escapeHTML: false,
      templates: { empty: '<div class="ais-Hits--empty"></div>', item: wkHitsTemplate }
    }));

    const ppag = qs('[data-wk-pagination]', panel);
    if (ppag) widgets.push(window.instantsearch.widgets.pagination({ container: ppag, padding: 2 }));

    if (widgets.length) search.addWidgets(widgets);

    // Sorting in panel (zelfde styling via CSS)
    const panelSort = qs('[data-wk-sorting] select[name="order"]', panel);
    bindSortSelect(panelSort, search);

    // Recent & popular in panel
    const recentEl  = qs('[data-wk-recent-queries]', panel);
    const popularEl = qs('[data-wk-popular-queries]', panel);
    renderRecentInto(recentEl);
    renderPopularInto(popularEl, host, key, docsIx);
    wireQueryPills(panel, search);

    // Panel tonen bij >= 2 tekens (zonder scrollIntoView → geen verspringen)
    const viewAll = document.getElementById('wk-view-all');
    search.on('render', () => {
      const q = (search.helper?.state?.query || '').trim();
      const show = q.length >= 2;
      panel.hidden = !show;

      if (viewAll) {
        if (show) {
          const target = (document.querySelector('meta[name="meili:resultspage"]')?.content || '/zoeken');
          viewAll.href = `${target}?q=${encodeURIComponent(q)}`;
          viewAll.hidden = false;
        } else {
          viewAll.hidden = true;
        }
      }

      if (q) {
        pushRecent(q);
        renderRecentInto(recentEl || qs('[data-wk-recent-queries]'));
      }
    });
  }

  /* ---------- Start ---------- */
  search.start();
  window.__wkSearchInit = true;
}

document.addEventListener('DOMContentLoaded', initWKSearch);
